import { BaseModel } from "sjs-base-model";
import NotaValoriModel from "./NotaValoriModel";

export default class NotaEstimateModel extends BaseModel {
    public readonly idNote: number = 0;
    public readonly description: string = "";
    public readonly userName: string = "";
    public readonly userSurname: string = "";
    public readonly customerName: string = "";
    public readonly customerSurname: string = "";
    public readonly insertDate: string = "";
    public readonly idEstimate: number = 0;
    public readonly idEstimateRequest: number = 0;
    public readonly noteType: NotaValoriModel = new NotaValoriModel({});
    public readonly isRead: boolean = false;

    constructor(data: Partial<NotaEstimateModel>) {
        super();

        this.update(data);
    }
}
